import Swiper from 'swiper';

class SliderSite {

  constructor(){
    this.sliderSingle      = document.querySelector('[data-component="single-slider"]');
    this.sliderHistorique  = document.querySelector('[data-component="historique-slider"]');
    this.sliderPartenaires = document.querySelector('[data-component="partenaires-slider"]');
		this._init();
  }

  _init(){
    
    document.addEventListener('DOMContentLoaded', (event) => {

      if( this.sliderSingle ){
        
        let swiper = new Swiper('[data-component="single-slider"]', {
          pagination         : '[data-component="single-slider-pagination"]',
          paginationClickable: true,
          autoplay           : 5000
        });

      }

      if( this.sliderHistorique ){
        
        let swiper = new Swiper('[data-component="historique-slider"]', {
          pagination         : '[data-component="historique-slider-pagination"]',
          paginationClickable: true,
          autoplay           : 5000
        });

      }

      if( this.sliderPartenaires ){
        
        let swiper = new Swiper('[data-component="partenaires-slider"]', {
          // pagination         : '[data-component="partenaires-slider-pagination"]',
          // paginationClickable: true,
          slidesPerView: 5,
          spaceBetween : 50,
          breakpoints  : {
              1024: {
                  slidesPerView: 4,
                  spaceBetween : 40
              },
              768: {
                  slidesPerView: 3,
                  spaceBetween : 30
              },
              640: {
                  slidesPerView: 2,
                  spaceBetween : 20
              },
              320: {
                  slidesPerView: 1,
                  spaceBetween : 10
              }
          },
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          autoplay  : 5000
        });

      }

    });
  }

}

export const sliderSite = new SliderSite();